import Vue from "vue";
import VueClipboard from "vue-clipboard2";

Vue.use(VueClipboard);

// From: https://www.npmjs.com/package/vue-clipboard2
// Let vue-clipboard2 set container to current element, needed to copy elements to clipboard
VueClipboard.config.autoSetContainer = true;
